<template>
  <el-drawer customClass="el-drawer-right" title="充值金额" :visible="visible" v-on="$listeners">
    <div class="content">
      <span class="custom-title">已选{{ dataList.length }}家需充值药店</span>
      <div class="fast-operate-line">
        <span class="hint-label">建议充值金额：</span>
        <el-button v-for="amount in amountList" :key="amount" size="mini" plain @click="handleAutoInput(amount)">
          {{ amount }}
        </el-button>
      </div>
      <span class="bottom-hint">
        单门店充值{{ amountList[0] }}元预估可至少消耗30天，建议您至少充值{{ amountList[0] }}元
      </span>
      <el-table
        :data="dataList"
        style="width: 100%"
        size="medium"
        header-row-class-name="common-table-header"
        row-class-name="common-table-row"
        class="is-print-hide common-table"
        :border="true"
      >
        <!-- <el-table-column prop="accountId" label="账户编号" width="180"></el-table-column> -->
        <el-table-column prop="merchantId" label="结算门店编号"></el-table-column>
        <el-table-column prop="customerName" label="结算门店名称" width="400">
          <template #default="{ row }">
            <el-tooltip effect="dark" :content="row.customerName" placement="top">
              <span>{{ row.customerName }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column prop="accountAmount" label="余额(元)">
          <template slot-scope="{ row }">
            {{ row.accountAmount | fen2Yuan }}
          </template>
        </el-table-column>
        <el-table-column label="充值金额" width="180">
          <template #default="{ row }">
            <div class="pay-box">
              <el-input
                :value="row.amount"
                @input="handleInput($event, row)"
                @blur="handleBlur($event, row)"
                placeholder="请输入"
                size="mini"
                style="width: 80px"
              ></el-input>
              <span class="pay-hint">{{ sill[row.accountId] }}元起充</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="footer">
      <div class="left">
        <span class="" style="font-size: 14px; color: #8c8c8c">总金额</span>
        <span class="price">{{ totalPrice }}</span>
        <span>（目前仅支持</span>
        <!--        <img style="width: 18px; margin: 0 2px" :src="require('@/assets/img/alipay.png')" alt="" />-->
        <!--        <span>支付宝、</span>-->
        <img style="width: 20px; margin: 0 2px" :src="require('@/assets/img/wepay.png')" alt="" />
        <span>微信充值）</span>
      </div>
      <div class="right">
        <el-button type="primary" plain size="small" @click="$emit('update:visible', false)">取消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit">提交</el-button>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import payDialog from '@/components/global/payDialog';
import ZYPay, { getTradeInfo } from '@zyf2e/checkout-sdk';
import { Loading, Message } from 'element-ui';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      amountList: [100, 200, 500, 1000],
      sill: []
    };
  },
  watch: {
    async visible(val) {
      if (val) {
        const res = await Fetch.getRechargeLimitInfo({
          accountIds: this.dataList.map(item => item.accountId)
        });
        this.amountList = Array.isArray(res.gears) ? res.gears.map(val => (val / 100).toFixed(0)) : [];
        Object.keys(res.sill).forEach(key => {
          res.sill[key] = (res.sill[key] / 100).toFixed(0);
        });
        this.sill = res.sill;
      }
    }
  },
  computed: {
    totalPrice() {
      return this.dataList
        .reduce((pre, item) => {
          return pre + (Number(item.amount) || 0);
        }, 0)
        .toFixed(2);
    }
  },
  methods: {
    handleAutoInput(amount) {
      this.dataList.forEach(item => {
        this.$set(item, 'amount', amount);
      });
    },
    async handleSubmit() {
      const flag = this.dataList.every(item => item.amount);
      if (!flag) {
        this.$message.error('请填写金额');
        return;
      }
      const params = this.dataList.map(({ accountId, amount }) => ({
        accountId,
        amount: parseInt((amount * 100).toFixed(0))
      }));
      const loadingService = Loading.service({
        text: '正在努力加载中....',
        background: 'rgba(0, 0, 0, 0)'
      });
      try {
        const { tradeNo } = await Fetch.o2oPay({
          rechargeDetailList: params,
          sourceChannel: 1
        });
        await ZYPay.init({
          bizId: 'O2O_RECHARGE',
          bizSource: 'O2O_RECHARGE',
          baseURL: Util.getGwRoot,
          needLogin: false
        });
        const { data: orderInfo } = await getTradeInfo(tradeNo);
        const { systemTime, expireTime, amount: payPrice } = orderInfo;
        const countdown = (expireTime - systemTime) / 1000;
        const { alipay, wechat } = await ZYPay.getPayQRCode(tradeNo);
        const payBox = payDialog({
          tradeNo,
          aliPayString: alipay,
          weChatPayString: wechat,
          countdown,
          payPrice,
          tip: '您已充值成功',
          onPaySuccess: () => {
            console.log('onPaySuccess');
          },
          onConfirmPayCompleted: () => {
            console.log('onConfirmPayCompleted');
            payBox.close();
            this.$emit('update:visible', false);
            this.$emit('paySuccess');
          }
        });
        loadingService.close();
        payBox.show();
      } catch (error) {
        loadingService.close();
        console.log(error);
        const { message = '支付异常，请返回重试 ' } = error || {};
        Message.error(message);
      }
    },
    handleInput(val, row) {
      if (/^-?\d{0,12}(\.\d{0,2})?$/.test(val)) {
        if (row.amount == undefined) {
          this.$set(row, 'amount', val);
        } else {
          row.amount = val;
        }
      }
    },
    handleBlur(e, row) {
      const limit = this.sill[row.accountId];
      if (row.amount && Number(row.amount) < Number(limit)) {
        row.amount = limit;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.el-drawer-right {
  width: 920px !important;
  .el-drawer__header {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05) !important;
    padding: 16px 24px;
    margin-bottom: 0;
    span {
      font-size: 16px !important;
      color: #262626;
      font-weight: 500;
    }
  }
  .el-drawer__body {
    padding: 24px 24px 80px;
    overflow-y: hidden;

    .content {
      height: 100%;
      overflow-y: auto;
    }
  }
  .custom-title {
    display: block;
    font-size: 14px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    color: #262626;
    line-height: 14px;
  }
  .fast-operate-line {
    display: flex;
    align-items: center;
    margin: 12px 0;
    .hint-label {
      font-size: 14px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      color: #262626;
      line-height: 14px;
    }
  }
  .bottom-hint {
    display: block;
    font-size: 12px;
    color: #8c8c8c;
    line-height: 14px;
    margin-bottom: 12px;
  }
  .pay-box {
    display: flex;
    align-items: center;
    .pay-hint {
      display: inline-block;
      font-weight: 400;
      font-size: 14px;
      color: #bfbfbf;
      line-height: 14px;
      margin-left: 8px;
    }
  }
  .footer {
    position: fixed;
    right: 0;
    bottom: 0;
    width: 920px;
    // width: 420px;
    padding: 12px;
    // text-align: right;
    border-top: 1px solid rgba(0, 0, 0, 0.05);
    display: flex;
    align-items: center;
    justify-content: space-between;
    .left {
      display: flex;
      font-size: 14px;
      color: #8c8c8c;
      align-items: center;
      .price {
        font-size: 18px;
        color: #ff4e47;
        line-height: 28px;
        font-weight: 600;
        &::before {
          display: inline-block;
          width: 10px;
          content: '￥';
          font-size: 14px;
        }
      }
    }
  }
}
</style>
